import React, { useState } from 'react';
import { SmlsInputText } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import MobileFlightSearch from '../MobileFlightSearch';

const HomeMobileFlightSearch: React.FC = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { t } = useTranslation('flightSearch');

  return (
    <div className="smls-flight-search-mobile">
      <div className="wrapper">
        <div className="content">
          <SmlsInputText
            id="HomeMobileFlightSearch-open-modal"
            onClick={() => setIsOpenModal(true)}
            placeholder={t('titleMobile')}
            icon={<i className="material-icons">search</i>}
            readOnly
          />
        </div>
      </div>

      <MobileFlightSearch
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
      />
    </div>
  );
};

export default HomeMobileFlightSearch;
